import type { SVGProps } from 'react';

export const Minimize = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 12.5a.8.8 0 0 1-.55-.2.8.8 0 0 1-.2-.55.7.7 0 0 1 .2-.525.75.75 0 0 1 .55-.225h10q.325 0 .525.225.225.2.225.525t-.225.55a.7.7 0 0 1-.525.2z" />
    </svg>
  );
};
